import React, { useEffect, useState } from 'react'
import EmployeeDetails from '../../EmployeeContainer/EmployeeDetails';
import Buttons from '../../../components/UI/Buttons';
import { formatPhoneNumberUS } from '../../../utils/commonUtils';
import Icons from '../../../components/UI/Icons';

const NewPatientDetails = (props) => {
     const [viewModelOpen,setViewModelOpen]=useState(false);
     const {employeeDetails,employeeId}=props;
     const [localDetails, setLocalDetails] = useState(employeeDetails);

   useEffect(() => {
      setLocalDetails(employeeDetails);
   }, [employeeDetails]);
   const viewPatientDetails = () => {
      setViewModelOpen(!viewModelOpen);
   }
   const handleImmediateUpdate = (updatedData) => {
      if(updatedData){
         setLocalDetails(prev => ({...prev, ...updatedData}));
      }
      props.fetchEmployeeDetails(employeeId);
   };

 
   const PatientName = `${localDetails?.first_name || ''} ${localDetails?.last_name || ''}`;
   const phoneNumber = localDetails?.phone ? formatPhoneNumberUS(localDetails['phone']) : '';
   console.log('EmployeeDetails', employeeDetails);
    const calculatedAge = (value) => {
         // console.log('valuevalue',value);
           if (!value) return null; // Return null if DOB is not set
           
            const today = new Date();
           const birthDate = new Date(value);
           if (isNaN(birthDate.getTime())) {
             return ''; // Return null if DOB is invalid
           }
           let age = today.getFullYear() - birthDate.getFullYear();
           const monthDiff = today.getMonth() - birthDate.getMonth();
           
           if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
               age--;
           }
           
           return age;
       };
  
   const age= localDetails?.dob ? calculatedAge(localDetails.dob) : null;
   const first_name=localDetails?.first_name?.charAt(0).toUpperCase() || '';
   const last_name=localDetails?.last_name?.charAt(0).toUpperCase() ||'';
  return (
       <>
        {
             viewModelOpen?
             <EmployeeDetails
             employeeId={props.employeeId}
             modalToogleHandler={viewPatientDetails}
             fetchEmployeeList={(data) => handleImmediateUpdate(data)}
             company_id={employeeDetails?.company?.company_uuid}
             />
             :
             ''
           }
        <div class="sh_cardBox mb-3 h-auto sh_cardbglight sh_emrpatientDetailsCard shadow">
           <div class="sh_cardHeader">
              <div class="d-flex align-items-center justify-content-between">
                 <h6 class="text-md font-weight-bold mb-0">Patient Details </h6>
                 <Buttons
                    className="btn btn-link"
                    label={"View More"}
                    acl={'any'}
                    clickHandler={viewPatientDetails} />
              </div>
           </div>
           <div class="sh_cardBody py-0">
              <div class="d-flex ">
                 {/* <span class="pr-1">
                    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <rect width="56" height="56" rx="28" fill="#F0F3FD"></rect>
                       <path d="M28 28C26.46 28 25.1417 27.4517 24.045 26.355C22.9483 25.2584 22.4 23.94 22.4 22.4C22.4 20.86 22.9483 19.5417 24.045 18.445C25.1417 17.3484 26.46 16.8 28 16.8C29.54 16.8 30.8583 17.3484 31.955 18.445C33.0517 19.5417 33.6 20.86 33.6 22.4C33.6 23.94 33.0517 25.2584 31.955 26.355C30.8583 27.4517 29.54 28 28 28ZM19.6 39.2C18.83 39.2 18.1711 38.9261 17.6232 38.3782C17.0744 37.8294 16.8 37.17 16.8 36.4V35.28C16.8 34.4867 17.0044 33.7573 17.4132 33.0918C17.8211 32.4273 18.3633 31.92 19.04 31.57C20.4867 30.8467 21.9567 30.304 23.45 29.9418C24.9433 29.5806 26.46 29.4 28 29.4C29.54 29.4 31.0567 29.5806 32.55 29.9418C34.0433 30.304 35.5133 30.8467 36.96 31.57C37.6367 31.92 38.1789 32.4273 38.5868 33.0918C38.9956 33.7573 39.2 34.4867 39.2 35.28V36.4C39.2 37.17 38.9261 37.8294 38.3782 38.3782C37.8294 38.9261 37.17 39.2 36.4 39.2H19.6ZM19.6 36.4H36.4V35.28C36.4 35.0234 36.3361 34.79 36.2082 34.58C36.0794 34.37 35.91 34.2067 35.7 34.09C34.44 33.46 33.1683 32.9873 31.885 32.6718C30.6017 32.3573 29.3067 32.2 28 32.2C26.6933 32.2 25.3983 32.3573 24.115 32.6718C22.8317 32.9873 21.56 33.46 20.3 34.09C20.09 34.2067 19.9211 34.37 19.7932 34.58C19.6644 34.79 19.6 35.0234 19.6 35.28V36.4ZM28 25.2C28.77 25.2 29.4294 24.9256 29.9782 24.3768C30.5261 23.829 30.8 23.17 30.8 22.4C30.8 21.63 30.5261 20.9711 29.9782 20.4232C29.4294 19.8744 28.77 19.6 28 19.6C27.23 19.6 26.5711 19.8744 26.0232 20.4232C25.4744 20.9711 25.2 21.63 25.2 22.4C25.2 23.17 25.4744 23.829 26.0232 24.3768C26.5711 24.9256 27.23 25.2 28 25.2Z" fill="#1D2433" fill-opacity="0.8"></path>
                    </svg>
                 </span> */}
                         <div
                      className="img-profile rounded-circle mr-2"
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "50%",
                          backgroundColor: "#F0F3FD", // or random color
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                       <Icons type="NewPatientDetailsIcon"  />
                      </div>
                 <div class="d-flex flex-column">
                    <h3 class="h3-strong mb-0">{PatientName}</h3>
                    <p class=" mb-0 text-dark p2-light">ID: #{employeeDetails.patient_id}</p>
                 </div>
              </div>
              <div class="row">
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                    <label class="f-400 text-sm text-truncate mb-0 opacity-75">Age</label></div>
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                   <h6 class="font-weight-bold text-sm text-lg-right text-md-left text-truncate mb-0">{age !== null ? `${age} Years` : ""}</h6>                 
                 </div>
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                    <label class="f-400 text-sm text-truncate mb-0 opacity-75">DOB</label></div>
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                   <h6 class="font-weight-bold text-sm text-lg-right text-md-left text-truncate mb-0">{localDetails?.dob}</h6>                 
                 </div>
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                    <label class="f-400 text-sm text-truncate mb-0 opacity-75">ID Type</label></div>
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                   <h6 class="font-weight-bold text-sm text-lg-right text-md-left text-truncate mb-0">{localDetails?.identification_type}</h6>                 
                 </div>
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                    <label class="f-400 text-sm text-truncate mb-0 opacity-75">ID Number</label></div>
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                   <h6 class="font-weight-bold text-sm text-lg-right text-md-left text-truncate mb-0">{localDetails?.identification_number}</h6>                 
                 </div>
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                    <label class="f-400 text-sm  text-truncate mb-0 opacity-75">Phone</label></div>
                 <div class="col-lg-6 col-md-12 col-12 pt-2">
                    <h6 class="font-weight-bold text-sm text-lg-right text-md-left text-truncate mb-0" title="">{phoneNumber}</h6>
                 </div>
              </div>
           </div>
        </div>
      </>
  )
}

export default NewPatientDetails